export default __webpack_public_path__ + "static/media/965.8b6a354c.gif";